import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listDemandSuppressionMasters } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  ListDemandSuppressionMastersRequestSchema,
  type ListDemandSuppressionMastersResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 需要抑制計画マスタ 一覧取得 hook。
 */
export function useListDemandSuppressionMasters(): UseQueryResult<
  ListDemandSuppressionMastersResponse,
  ConnectError
> {
  return useQuery(
    listDemandSuppressionMasters,
    create(ListDemandSuppressionMastersRequestSchema),
  )
}
